export default __webpack_public_path__ + "static/international-transaction-fees-2b4d396f8f31b0cb044293ddea6b6d09.jpg";